import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/dist/vuetify.min.css'
import Vue from 'vue'
import Vuetify from 'vuetify'
import Vuelidate from 'vuelidate'

import router from './router'
import store from './store'

import App from './theme/default/App.vue'

Vue.use(Vuetify)
Vue.use(Vuelidate)
const vuetify = new Vuetify()
Vue.config.productionTip = false

Vue.mixin({
  data(){
    return {
      BASE_URL: location.protocol+'//'+location.hostname
    }
  }
})

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
